import React from "react";
import { useNavigate } from "react-router-dom";
import { Bot, ArrowLeft } from "lucide-react";
import { Button } from "../components/ui/button";

const Section = ({ title, children }) => (
  <div className="mt-8">
    <h2 className="font-display text-2xl tracking-tight mb-3 text-primary">{title}</h2>
    <div className="space-y-2 text-muted-foreground leading-relaxed">{children}</div>
  </div>
);

export default function DataDeletion() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-background text-foreground grain" data-testid="data-deletion-page">
      <nav className="flex items-center justify-between px-6 md:px-12 py-5 border-b border-white/10 bg-[#0a0a0a] sticky top-0 z-50" style={{ paddingTop: "calc(1.25rem + env(safe-area-inset-top))" }}>
        <div className="flex items-center gap-2.5">
          <div className="h-9 w-9 bg-primary rounded-sm flex items-center justify-center"><Bot className="h-5 w-5 text-white" /></div>
          <span className="font-display text-2xl tracking-wide">TRADIE<span className="text-primary">DESK</span></span>
        </div>
        <Button data-testid="data-deletion-back-btn" variant="ghost" onClick={() => navigate(-1)} className="rounded-sm gap-2 text-foreground hover:text-primary hover:bg-secondary">
          <ArrowLeft className="h-4 w-4" /> Back
        </Button>
      </nav>
      <div className="max-w-3xl mx-auto px-6 md:px-8 py-12">
        <div className="bg-[#18181b] border border-white/10 rounded-sm p-6 md:p-10">
          <h1 className="font-display text-3xl md:text-4xl tracking-tight mb-2">Data Deletion Instructions</h1>
          <p className="text-sm text-muted-foreground">Last updated: June 2026</p>

          <Section title="Delete your data yourself">
            <p>If you're a TradieDesk business owner, you can remove your data directly from the dashboard at any time:</p>
            <p>• Delete individual leads and bookings from the <span className="text-foreground">Leads</span> and <span className="text-foreground">Bookings</span> tabs.</p>
            <p>• Disconnect a connected Facebook Page from the <span className="text-foreground">Connect</span> tab — this immediately stops us processing or storing any further Messenger data for that Page.</p>
            <p>• Close your account from <span className="text-foreground">Billing → Close account</span>, which removes your business profile and associated records.</p>
          </Section>

          <Section title="Request deletion by email">
            <p>If you contacted a TradieDesk business through Facebook Messenger and want the message data associated with you deleted, or you'd like us to erase any personal data we hold, email <a href="mailto:hello@tradiedesk.net" className="text-primary underline">hello@tradiedesk.net</a> with the subject line <span className="text-foreground">"Data deletion request"</span>.</p>
            <p>Please include enough detail for us to identify the data (for example the Facebook Page you messaged and your name). We will delete the relevant data and confirm within 30 days.</p>
          </Section>

          <Section title="What gets deleted">
            <p>We remove the stored conversation, any captured contact details and, where applicable, the associated lead or booking records. Some minimal records may be retained only where required by law.</p>
          </Section>
        </div>
      </div>
    </div>
  );
}
